var APIROOT = {};


// 来判断不同的生产环境和正式环境
if (process.env.NODE_ENV && process.env.NODE_ENV === 'development') {

	APIROOT.serverNotice = 'https://transtest.fanghenet.com',
	APIROOT.serverCommon = 'https://transtest.fanghenet.com',
	APIROOT.serverZhou = 'https://transtest.fanghenet.com'

} else {
	if (window.location.href.indexOf('test') > 0) {
		APIROOT.serverNotice = 'https://transtest.fanghenet.com',
			APIROOT.serverCommon = 'https://transtest.fanghenet.com',
			APIROOT.serverZhou = 'https://transtest.fanghenet.com'
	} else {
		APIROOT.serverNotice = 'https://trans.fanghenet.com',
			APIROOT.serverCommon = 'https://trans.fanghenet.com',
			APIROOT.serverZhou = 'https://trans.fanghenet.com'
	}
}

export default APIROOT



// WEBPACK FOOTER //
// ./src/utils/config.js